import { render, staticRenderFns } from "./ProcessingRequestLanding.vue?vue&type=template&id=1211fa84&scoped=true"
import script from "./ProcessingRequestLanding.vue?vue&type=script&lang=js"
export * from "./ProcessingRequestLanding.vue?vue&type=script&lang=js"
import style0 from "./ProcessingRequestLanding.vue?vue&type=style&index=0&id=1211fa84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211fa84",
  null
  
)

export default component.exports